import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import * as fromModel from '../../services/models/';
import { Constant } from '../../../environments/constants';
import { Utils } from '../../../utils/utils';



export const INIT_REF_DATA: fromModel.IRefData = {
  action: fromModel.REF_DATA_ACTION.NONE,
  actionDispatchedBy: 'Initial',
  actionHistory: [],
  StateExpense: null,
  KeyValue: null,
  LifeExpectancy: null,
  PlanningUI: null,
  AccType: null
};

@Injectable({
  providedIn: 'root'
})
export class RefDataService {

  protected refDataSubject: BehaviorSubject<fromModel.IRefData>;
  public refData: fromModel.IRefData; 

  constructor() { 
    this.refData = JSON.parse(JSON.stringify(INIT_REF_DATA));
    this.refDataSubject = new BehaviorSubject<fromModel.IRefData>(this.refData);
  }

  public subscribe(callback: (context: fromModel.IRefData) => void): Subscription{
    return this.refDataSubject.subscribe(callback);    
  }

  public dispatchAction(act: fromModel.REF_DATA_ACTION, dispatchedBy: string, payload: any | null): void {
    console.log(`%c Ref Data - Action: ${act}; By: ${dispatchedBy}`, Constant.consoleLogStyle.documentContext);
    this.refData.action = act;
    this.refData.actionDispatchedBy = dispatchedBy;
    this.refData.actionHistory.push(`${act}: ${dispatchedBy}`);
    let _contextUpdateReq = true;

    switch (act){
      case fromModel.REF_DATA_ACTION.NONE:
        console.log('%c App Context - No Action', Constant.consoleLogStyle.documentContext);
        break;
      case fromModel.REF_DATA_ACTION.RESET:  
        console.log('%c Reset App Context', Constant.consoleLogStyle.documentContext);
        this.refData = JSON.parse(JSON.stringify(INIT_REF_DATA));      
        break;
      case fromModel.REF_DATA_ACTION.STATEEXP:
        this.refData.StateExpense = payload;
        break;
      case fromModel.REF_DATA_ACTION.KEYVALUE:
        this.refData.KeyValue = payload;
        break;
      case fromModel.REF_DATA_ACTION.LIFEEXPECTANCY:
        this.refData.LifeExpectancy = payload;
        break;
      case fromModel.REF_DATA_ACTION.PLANNINGUI:
        this.refData.PlanningUI = payload;
        break;
      case fromModel.REF_DATA_ACTION.ACCTYPE:
        this.refData.AccType = payload;
        break;

    }

    // console.log(JSON.stringify(this.context));  
    const dispatchedContext: fromModel.IRefData = JSON.parse(JSON.stringify(this.refData));    
    this.refDataSubject.next(dispatchedContext);
  } 

  public getLifeExpectancyForClient(clientAge, clientGender, clientHealthCondition: fromModel.HEALTHCONDITION, clientSmoker:fromModel.SMOKER){
    let lifeExpectancy;
    let _le;
    if(this.refData.LifeExpectancy && this.refData.LifeExpectancy.length>0){
      if(clientAge<30){
        _le = this.refData.LifeExpectancy.filter(({age, gender, health, smoker}) => age===30 &&  gender === clientGender && health===clientHealthCondition && smoker === clientSmoker);        
      } else if(clientAge>90){
        _le = this.refData.LifeExpectancy.filter(({age, gender, health, smoker}) => age===90 &&  gender === clientGender && health===clientHealthCondition && smoker === clientSmoker);
      } else {
        _le = this.refData.LifeExpectancy.filter(({age, gender, health, smoker}) => (clientAge>= age && clientAge<age+5) &&  gender === clientGender && health===clientHealthCondition && smoker === clientSmoker);
      }
      if(_le.length>0){
        lifeExpectancy = _le[0];
      }
    }
    return lifeExpectancy;
  }

  public getAllExpensesRefData(): fromModel.CodeValue[] {
    let refExpenses:  fromModel.CodeValue[];
    if(this.refData && this.refData.PlanningUI && this.refData.PlanningUI.expenses && this.refData.PlanningUI.expenses.length>0){
      refExpenses = this.refData.PlanningUI.expenses;      
    }
    return refExpenses;
  }

  public getExpenseByType(expType: fromModel.EXPENSETYPE): fromModel.CodeValue {
    let refExpense:  fromModel.CodeValue;
    if(this.refData && this.refData.PlanningUI && this.refData.PlanningUI.expenses && this.refData.PlanningUI.expenses.length>0){
      const _refExp = this.refData.PlanningUI.expenses.find(refExp=> refExp.code === expType);
      if(_refExp){
        refExpense = _refExp;
      }      
    }
    return refExpense;
  } 

  public getPlanningUIRefDataByType(type: fromModel.PLANNINGUIREFTYPE): fromModel.CodeValue[] {
    let refData:  fromModel.CodeValue[];
    if(this.refData && this.refData.PlanningUI){
      switch(type){
        case fromModel.PLANNINGUIREFTYPE.EmploymentTypes:
          refData = this.refData.PlanningUI.EmploymentTypes && this.refData.PlanningUI.EmploymentTypes;
          break; 
        case fromModel.PLANNINGUIREFTYPE.Settings:
          refData = this.refData.PlanningUI.settings && this.refData.PlanningUI.Settings;
          break; 
        case fromModel.PLANNINGUIREFTYPE.StartType:
          refData = this.refData.PlanningUI.StartType && this.refData.PlanningUI.StartType;
          break;  
        case fromModel.PLANNINGUIREFTYPE.EndType:
          refData = this.refData.PlanningUI.EndType && this.refData.PlanningUI.EndType;
          break;
        case fromModel.PLANNINGUIREFTYPE.Expenses:
          refData = this.refData.PlanningUI.Expenses && this.refData.PlanningUI.Expenses;
          break;        
        case fromModel.PLANNINGUIREFTYPE.Goals:
          refData = this.refData.PlanningUI.Goals && this.refData.PlanningUI.Goals;
          break;
        case fromModel.PLANNINGUIREFTYPE.GrowthRates:
          refData = this.refData.PlanningUI.GrowthRates && this.refData.PlanningUI.GrowthRates;
          break;
        case fromModel.PLANNINGUIREFTYPE.Incomes:
          refData = this.refData.PlanningUI.Incomes && this.refData.PlanningUI.Incomes;
          break;
        case fromModel.PLANNINGUIREFTYPE.Savings:
          refData = this.refData.PlanningUI.Savings && this.refData.PlanningUI.Savings;
          break;
        case fromModel.PLANNINGUIREFTYPE.GoalsColor:
          refData = this.refData.PlanningUI.GoalsColor && this.refData.PlanningUI.GoalsColor;
          break;
        case fromModel.PLANNINGUIREFTYPE.ClientsColor:
          refData = this.refData.PlanningUI.ClientsColor && this.refData.PlanningUI.ClientsColor;
          break;
        case fromModel.PLANNINGUIREFTYPE.GoalsPriority:
          refData = this.refData.PlanningUI.GoalsPriority && this.refData.PlanningUI.GoalsPriority;
          break;
        case fromModel.PLANNINGUIREFTYPE.IncomeChart:
          refData = this.refData.PlanningUI.IncomeChart && this.refData.PlanningUI.IncomeChart;
          break;
        case fromModel.PLANNINGUIREFTYPE.PrimaryIncomeColors:
          refData = this.refData.PlanningUI.PrimaryIncomeColors && this.refData.PlanningUI.PrimaryIncomeColors;
          break;
        case fromModel.PLANNINGUIREFTYPE.SecondaryIncomeColors:
          refData = this.refData.PlanningUI.SecondaryIncomeColors && this.refData.PlanningUI.SecondaryIncomeColors;
          break;
        case fromModel.PLANNINGUIREFTYPE.JointIncomeColors:
          refData = this.refData.PlanningUI.JointIncomeColors && this.refData.PlanningUI.JointIncomeColors;
          break;
        case fromModel.PLANNINGUIREFTYPE.Colors:
          refData = this.refData.PlanningUI.Colors && this.refData.PlanningUI.Colors;
          break;
      }
    }
    return refData;
  }

  public getPlanningUIRefDataByTypeCode(type: fromModel.PLANNINGUIREFTYPE, code: string): fromModel.CodeValue {
    let codeValue: fromModel.CodeValue;    
    let refData:  fromModel.CodeValue[] = this.getPlanningUIRefDataByType(type);
    codeValue = refData.find(codeValue=>codeValue.code === code);    
    return codeValue;
  }
  
  public getKeyValueByCode(code: string){
    let codeValue;
    for (const [key, value] of Object.entries(this.refData.KeyValue)) {
      if(key === code){
        codeValue = value;
        return codeValue;
      }
    }
    return codeValue;
  }

  public getAccRefByAccType(code: string): fromModel.AccRef{
    let accRef: fromModel.AccRef;
    if(this.refData.AccType && this.refData.AccType.length>0){
      accRef = <fromModel.AccRef>this.refData.AccType.find(_accRef=>_accRef.code.toUpperCase() === code.toUpperCase());        
    }
    return accRef;
  }

  // public getKeyValueByCode(code: string){
  //   let value;
  //   let data =  this.refData.KeyValue;
  //   let refDataKeys =  Object.keys(data);
  //   let refDataValues = Object.values(data);
  //   value = refDataKeys.find(_code=>_code === code);    
  //   return value;
  // }
}
